import { render, staticRenderFns } from "./DashboardFooter.vue?vue&type=template&id=67cee822"
import script from "./DashboardFooter.vue?vue&type=script&lang=js"
export * from "./DashboardFooter.vue?vue&type=script&lang=js"
import style0 from "./DashboardFooter.vue?vue&type=style&index=0&id=67cee822&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports